import { Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Card } from "styledComponents/component";
import MuiAccordion from "../MuiAccordion";

const useStyles = makeStyles(() => ({
	tooltip: {
		maxWidth: 250,
		fontSize: 12,
		padding: 5,
	},
}));
export default function MainBox({
	headerTitle,
	toolTipText,
	headerDropDown,
	children,
	height,
	accordion,
	className,
	parentHeight,
	overflowNone,
}) {
	return (
		<div className={`${className ? className : ""}`}>
			{accordion ? (
				<MuiAccordion
					header={
						<div
							className="flex justify-between items-center "
							style={{ width: "max-content", maxWidth: "100%" }}>
							<Header headerTitle={headerTitle} toolTipText={toolTipText} />
						</div>
					}>
					<div
						className={`flex justify-between items-center ${
							headerDropDown && "mt-2"
						}`}>
						{headerDropDown && headerDropDown}
					</div>
					<div
						className={`flex p-3`}
						style={{ height: `${height ? height : "auto"}px` }}>
						{children}
					</div>
				</MuiAccordion>
			) : (
				<Card
					style={{ overflow: overflowNone ? "" : "auto" }}
					height={parentHeight ? parentHeight : ""}
					minHeight={10}
					marginTop={"auto"}>
					{/*<BoxStyled style={{overflow: notOverFlow ? "" : 'auto'}} minHeight={10} marginTop={'auto'}>*/}
					<div
						className={`flex justify-between items-center ${
							headerDropDown && "mt-2"
						}`}>
						<div
							className="flex justify-between items-center "
							style={{ width: "max-content", maxWidth: "100%" }}>
							<Header headerTitle={headerTitle} toolTipText={toolTipText} />
						</div>
						{headerDropDown && headerDropDown}
					</div>
					<div
						className={`p-3`}
						style={{ height: `${height ? height : "auto"}` }}>
						{children}
					</div>
				</Card>
			)}
		</div>
	);
}

const Header = ({ headerTitle, toolTipText }) => {
	const classes = useStyles();
	return (
		<>
			<h1 className="pr-3  mt-2 mx-2">{headerTitle}</h1>
			{toolTipText && (
				<Tooltip
					className="mt-1"
					title={<p className="p-2 m-0">{toolTipText}</p>}
					placement="left"
					arrow
					classes={{ tooltip: classes.tooltip }}
					enterTouchDelay={1}>
					<img alt={"tooltipIcon"} src="/media/image/Group 12485.png" />
				</Tooltip>
			)}
		</>
	);
};
